

































import { Vue, Component } from 'vue-property-decorator';
import CourseSearch from './CourseSearch.vue';
import CourseStatusCount from './CourseStatusCount.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import CourseList from './components/CourseList.vue';
import {
  CourseFilterOptions,
  CourseListItem,
  CourseTypeDTO,
  FilteredCoursePayload,
  GetCoursesResponsePayload,
  initialFilterState
} from '@/store/modules/jtms/course/course.types';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { Pagination } from '@/store/modules/admin/types/admin.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import {
  GeneralQueryParams,
  PaginatorSpecs,
  SortEventData
} from '@/store/types/general.types';
import { CourseSortColumns } from '@/jbi-shared/types/jtms.types';

@Component({
  components: {
    ContentWrapper,
    BaseLoading,
    CourseSearch,
    CourseStatusCount,
    CourseList,
    BasePaginatorHoc
  }
})
export default class JTMSDashboardOverview extends Vue {
  perPage = 50;
  page = 1;
  sortColumn: string = 'courseName';
  sortOrder: SortOrder = SortOrder.ASC;

  courseFilterParams: CourseFilterOptions = { ...initialFilterState };
  queryParamsForCourses: FilteredCoursePayload = {
    ...this.courseFilterParams,
    limit: 50,
    page: 1,
    sortColumn: CourseSortColumns.NAME,
    sortOrder: SortOrder.ASC
  };

  @Action('course/getCourseTypes')
  getCourseTypes!: () => Promise<CourseTypeDTO[]>;

  @Action('course/getCourses')
  getCourses!: (
    options: FilteredCoursePayload
  ) => Promise<GetCoursesResponsePayload>;

  @Action('courseModule/clearActiveCourseModules')
  clearActiveCourseModules!: () => void;

  @Action('courseModule/clearDeletedCourseModules')
  clearDeletedCourseModules!: () => void;

  @Action('courseModule/updateCourseModuleFormError')
  updateCourseModuleFormError!: (payload: boolean) => void;

  @Action('course/updateCourseHasModules')
  updateHasModules!: (payload: boolean) => void;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeDTO[];

  @State(({ course }: RootState) => course.courses)
  courses!: Pagination<CourseListItem[]>;

  get CourseList() {
    return CourseList;
  }

  created() {
    this.getCourseList(this.queryParamsForCourses);
    this.getCourseTypes();
  }

  mounted() {
    // Clear state values from previous routes as safeguard
    this.clearActiveCourseModules();
    this.clearDeletedCourseModules();
    this.updateCourseModuleFormError(false);
    this.updateHasModules(false);

    this.handleResetFilter();
  }

  getCourseList(params: FilteredCoursePayload) {
    if (
      // Placeholder for future permissions check on user
      true
    ) {
      this.getCourses(params);
    }
  }

  refreshList() {
    this.getCourseList(this.queryParamsForCourses);
  }

  modifyQueryParams<T>(paramsMap: Map<string, T>) {
    for (const [key, value] of paramsMap.entries()) {
      if (key in this.queryParamsForCourses) {
        // Use type assertion to safely assign the value
        (this.queryParamsForCourses as Record<string, any>)[key] = value;
      }
    }
  }

  handleFilter() {
    const map = new Map();
    map.set('page', 1);

    // Dynamically map each course filter to the query params
    for (const [key, value] of Object.entries(this.courseFilterParams)) {
      if (key === 'endDate' && value) {
        map.set(key, new Date(value.setHours(23, 59, 59)));
      } else {
        map.set(key, value);
      }
    }

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleResetFilter() {
    this.courseFilterParams = { ...initialFilterState };
  }

  handleSort(data: SortEventData) {
    this.sortColumn = data.sortColumn;
    this.sortOrder = data.sortOrder;

    const map = new Map();
    map.set('sortColumn', data.sortColumn);
    map.set('sortOrder', data.sortOrder);

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handlePaginator(paginator: PaginatorSpecs) {
    this.perPage = paginator.perPage;
    this.page = paginator.page;

    const map = new Map();
    map.set('limit', paginator.perPage);
    map.set('page', paginator.page);

    this.modifyQueryParams(map);
    this.refreshList();
  }
}
